"use client";

import React from "react";
import { Card, CardHeader, CardBody, CardFooter, Avatar, Button, Image, AvatarGroup } from "@nextui-org/react";


import { Job } from "@/types/types";

interface FeaturesTableProps {
    job: Job | null;
}

const Profile: React.FC<FeaturesTableProps> = ({ job }) => {
    // console.log("----> xxx ", job?.Image.url)
    return (
        <div>
            <Card className="max-w-[240px] m-10 shadow-[rgba(0,_0,_0,_0.4)_0px_30px_90px]">
                <CardHeader className="pb-0 pt-2 px-4 flex-col items-start">
                    <p className="text-tiny uppercase font-bold">Suggérez/Corrigez</p>
                    <small className="text-default-500">2024</small>
                    <h4 className="font-bold text-large">Salaire - Métier</h4>
                </CardHeader>
                <CardBody className="overflow-visible py-2">
                    <Image
                        alt="Card background"
                        className="object-cover rounded-xl"
                        src={job?.Image.url}
                        width={270}
                    />
                </CardBody>
            </Card >

            <AvatarGroup isBordered max={3} total={10}>
                <Avatar src="https://i.pravatar.cc/150?u=a042581f4e29026024d" />
                <Avatar src="https://i.pravatar.cc/150?u=a04258a2462d826712d" />
                <Avatar src="https://i.pravatar.cc/150?u=a042581f4e29026704d" />
                <Avatar src="https://i.pravatar.cc/150?u=a04258114e29026302d" />
                <Avatar src="https://i.pravatar.cc/150?u=a04258114e29026702d" />
                <Avatar src="https://i.pravatar.cc/150?u=a04258114e29026708c" />
            </AvatarGroup>
        </div>

    );
}

export default Profile;